import React from 'react';
import HuaweiIcon from "../../assets/img/HuaweiIcon.svg";
import AppStoreIcon from "../../assets/img/AppstoreIcon.svg";
import PlayStoreIcon from '../../assets/img/GooglePlayIcon.svg';
import FirebaseAnalytics from "../../services/analytics.service";

const DownloadApps = (props) => {
    const { firebase_event_properties = {} } = props || {};
    const { event_screen = "", interaction_type= "" } = firebase_event_properties || {};

    const handleStoreClick = (storeName) => {
        if (props.onStoreClick) {
            props.onStoreClick(storeName);
        }

        //for handling firebase events
        if(event_screen && interaction_type) {
            const firebase_event_params = {
                event_screen,
                interaction_type,
                event_label: storeName,
                storeName
            }
            FirebaseAnalytics.commonFunction(firebase_event_params);
        }
    }

    return (
        <div className={props.classes}>
            {props.info ? <div className={`${props.classes}-label`}>{props.info}</div> : ""}
            <div className={`${props.classes}-container`}>
                {props.google_play_link &&
                    <a
                        href={props.google_play_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => handleStoreClick("google_play")}
                    >
                        <img src={PlayStoreIcon} alt="Play Store" />
                    </a>
                }
                {props.app_store_link &&
                    <a
                        href={props.app_store_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => handleStoreClick("app_store")}
                    >
                        <img src={AppStoreIcon} alt="App Store" />
                    </a>
                }
                {props.app_store_link &&
                    <a
                        href={props.huawei_store_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => handleStoreClick("app_gallery")}
                    >
                        <img src={HuaweiIcon} alt="Huawei" />
                    </a>
                }
                {props.children}
            </div >
        </div>
    );
}

export default DownloadApps;